export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_HOT = 'SET_HOT'
export const SET_SLIDE = 'SET_SLIDE'
export const SET_SONG_CATEGORY = 'SET_SONG_CATEGORY'
export const SET_ACTIVITY = 'SET_ACTIVITY'
export const HOT = 'HOT'
export const SET_ARTICLE = 'ARTICLE'
export const SET_SONG_TAG_LANG = 'SET_SONG_TAG_LANG'
export const SET_SONG_TAG_TEMPO = 'SET_SONG_TAG_TEMPO'
export const SET_SONG_LATEST = 'SET_SONG_LATEST'
export const SET_SONG_SPECIAL = 'SET_SONG_SPECIAL'
export const SET_SONG_SHARE = 'SET_SONG_SHARE'
export const SET_PARTNER_CATEGORY = 'SET_PARTNER_CATEGORY'
export const UPDATEUSER = 'UPDATEUSER'



// WEBPACK FOOTER //
// ./src/store/home/mutations_types.js